import { useEffect } from 'react';

const DEFAULT_OG_IMAGE = 'https://actgrants.in/wp-content/themes/act/images/logo.png';

export function usePageMeta({ title, description, ogImage }) {
  useEffect(() => {
    document.title = title || 'Talent Collective';

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(name.startsWith('og:') ? 'property' : 'name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) {
      setMeta('description', description);
      setMeta('og:description', description);
    }
    setMeta('og:title', title || 'Talent Collective');
    setMeta('og:image', ogImage || DEFAULT_OG_IMAGE);
    setMeta('og:type', 'website');
  }, [title, description, ogImage]);
}
